import { ifError } from "assert";

export default function getCookie(name: string) {
    let cookieValue = null;
    if (document && document?.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function getCSRFToken(cookie: string): string | undefined {
    const match = cookie.match(/csrftoken=([^\s;]+);?/)
    if (match) {
        return match[1]
    }
}

export function getSessionID(cookie: string): string | undefined {
    const match = cookie.match(/sessionid=([^\s;]+);?/)
    if (match) {
        return match[1]
    }
}